export default (() => {
  const parseText = (text) => {
    const parser = new DOMParser().parseFromString(text, "text/html");
    return parser.documentElement.textContent;
  };

  const displayToast = (type, title, copy, autoclose, link) => {
    window.eventbus.emit(window.EVENTS.SHOW_ALERT_REQUESTED, {
      type,
      title: parseText(title),
      copy: parseText(copy),
      autoclose,
      link,
    });
  };

  window.Amenitiz = {
    displaySuccessToast: (title, desc, autoclose, link) => {
      displayToast(
        window.BANNER_ALERT_TYPES.SUCCESS,
        title,
        desc,
        autoclose,
        link,
      );
    },
    displayErrorToast: (title, desc, autoclose, link) => {
      displayToast(
        window.BANNER_ALERT_TYPES.ERROR,
        title,
        desc,
        autoclose,
        link,
      );
    },
    displayWarningToast: (title, desc, autoclose, link) => {
      displayToast(
        window.BANNER_ALERT_TYPES.WARNING,
        title,
        desc,
        autoclose,
        link,
      );
    },
    tooltipTopCalculator: (tooltipParentClass, offset) => {
      const tooltipParents =
        document.getElementsByClassName(tooltipParentClass);

      for (const tooltipParent of tooltipParents) {
        const topOffset =
          window.pageYOffset + tooltipParent.getBoundingClientRect().top;
        const tooltip = document.getElementById(tooltipParent.dataset.tooltip);

        tooltip.style.top = `${(topOffset + offset).toString()}px`;

        tooltipParent.addEventListener("mouseenter", (e) => {
          tooltip.removeAttribute("hidden");

          const icon = tooltipParent.querySelector(".tooltip-info-icon");
          icon.classList.remove("black-child-svg");
          icon.classList.add("blue-child-svg");
        });

        tooltipParent.addEventListener("mouseleave", (e) => {
          tooltip.setAttribute("hidden", "true");

          const icon = tooltipParent.querySelector(".tooltip-info-icon");
          icon.classList.add("black-child-svg");
          icon.classList.remove("blue-child-svg");
        });
      }
    },
    selectorOpenOptions: (displayed) => {
      const selector = displayed.closest(".selector");
      selector.querySelector(".selector--options").removeAttribute("hidden");
    },
    selectorCloseOptions: (options) => {
      options.setAttribute("hidden", "true");
    },
    selectorChooseOption: (option, extraFunction) => {
      const { name } = option.dataset;
      const { id } = option.dataset;

      const selector = option.closest(".selector");
      selector.querySelector("input").value = id;

      if (id) {
        selector.querySelector(".option-displayed").removeAttribute("hidden");
        selector
          .querySelector(".empty-displayed")
          .setAttribute("hidden", "true");
        selector.querySelector(".option-displayed-name").innerHTML = name;
      } else {
        selector
          .querySelector(".option-displayed")
          .setAttribute("hidden", "true");
        selector.querySelector(".empty-displayed").removeAttribute("hidden");
      }

      selector
        .querySelector(".selector--options")
        .setAttribute("hidden", "true");

      if (extraFunction) {
        window[extraFunction](name, id);
      }
    },
    selectorRemoveOption: (option) => {
      const selector = option.closest(".selector");
      selector.querySelector("input").value = "";
      selector
        .querySelector(".option-displayed")
        .setAttribute("hidden", "true");
      selector.querySelector(".empty-displayed").removeAttribute("hidden");
      selector
        .querySelector(".selector--options")
        .setAttribute("hidden", "true");
    },
    validationFunctions: {
      "check-if-positive-number": (value) => !isNaN(value) && Number(value) > 0, // TRUE IF VALUE S A NUMBER AND IT IS POSTIVE
      "check-if-zero-or-positive-number": (value) => {
        value = value.replace(",", "."); // NUMBERS WITH COMMAS ARE NOT CONSIDERED NUMBERS IN JS, WE SHOULD USE NUMBER INPUTS
        return !isNaN(value) && Number(value) >= 0; // TRUE IF VALUE S A NUMBER AND IT IS POSTIVE
      },
      "check-if-select-has-a-selected-value": (value) => !!value,
      "check-if-presence": (value) => !!value,
    },
    validateInputGroup: ({ inputGroup, value, validation }) => {
      const validationFunction = Amenitiz.validationFunctions[validation];

      // IF WE HAVE A VALIDATION FUNCTION AND THE VALUE IS NOT VALID WE ADD THE ERROR
      if (validationFunction && !validationFunction(value)) {
        inputGroup.classList.add("a-validation-input-group--error");
        inputGroup.classList.remove("a-validation-input-group--success");
      } else {
        inputGroup.classList.remove("a-validation-input-group--error");
        inputGroup.classList.add("a-validation-input-group--success");
      }
    },
    fitTextElement: (element, maxSize) => {
      let fontSize = parseFloat(element.css("font-size"));
      // Respect font size set to 0 (for hiding the text)
      if (fontSize === 0) {
        return;
      }
      const originalFontSize = maxSize || fontSize;
      element.css("font-size", `${originalFontSize}px`);
      element.css("display", "inline-block");
      const parentWidth = element.parent().width();
      let elementWidth = element.width();
      while (elementWidth > parentWidth) {
        fontSize--;
        element.css("font-size", `${fontSize}px`);
        elementWidth = element.width();
      }
    },
    openDatePicker: (datepicker) => {
      datepicker.classList.add("inventory-table-input__date-picker--open");
    },
    closeDatePicker: (datepicker) => {
      datepicker.classList.remove("inventory-table-input__date-picker--open");
    },
    ReportIndexEmailStatusToSending: (index) => {
      const element = document.querySelector(`#report-list-element-${index}`);
      element.querySelector(".icon-report-loading").classList.remove("hide");
      element.querySelector(".icon-report-send").classList.add("hide");
    },
    ReportIndexEmailStatusToNormal: (index) => {
      const element = document.querySelector(`#report-list-element-${index}`);
      element.querySelector(".icon-report-send").classList.remove("hide");
      element.querySelector(".icon-report-loading").classList.add("hide");
    },
    correctDatepickerCalendarPosition: (pos, correction) => {
      const calendar = document.querySelector(
        ".datepicker.datepicker-dropdown.dropdown-menu",
      );
      const calendarPositionValue = calendar.style[pos];

      if (calendarPositionValue) {
        const match = /((\d+)(\.\d+)?)px/.exec(calendarPositionValue);
        const value = match ? Number(match[1]) : undefined;

        if (value)
          document.querySelector(
            ".datepicker.datepicker-dropdown.dropdown-menu",
          ).style[pos] = `${value + correction}px`;
      }
    },
    formatDate: (date) => {
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();

      return `${day}/${month < 10 ? `0${month}` : month}/${year}`;
    },
    getDateFromDatePicker: (datepickerSelector) => {
      const value = $(datepickerSelector).val(); // dd/mm/yyyy format
      const dateString = value.split("/").reverse().join("-"); // yyyy-mm-dd format
      return window.DateUtils.parseDateWithinTimezone(dateString);
    },
    compareDates: (a, b) => {
      const dateA = new Date(a);
      const dateB = new Date(b);

      dateA.setHours(0, 0, 0, 0);
      dateB.setHours(0, 0, 0, 0);

      // 0 dates are equals, < 0 date B is bigger, > 0 date A is bigger
      return dateA.getTime() - dateB.getTime();
    },
    hotelTimezone: () => {
      return document.querySelector("html").dataset.tz;
    },
    calculateNights: (arrivalDate, departureDate) => {
      const diffTime = Math.abs(departureDate - arrivalDate);
      const nights = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      return nights;
    },
    showCharacterCount: (element) => {
      // escaping &nbsp & html tags to avoid counting issue
      const textValue = element.innerHTML
        .replace(/\&nbsp;/g, "")
        .replace(/<[^>]*>/g, "");
      const characterWarningArea = document.querySelector(
        ".text-char-limit span",
      );
      const textLength = textValue.length;
      characterWarningArea.innerHTML = textLength;
      if (textLength > 500) {
        characterWarningArea.parentElement.classList.remove("color-success");
        characterWarningArea.parentElement.classList.add("color-error");
      } else {
        characterWarningArea.parentElement.classList.remove("color-error");
        characterWarningArea.parentElement.classList.add("color-success");
      }
    },
    loadFlickity: ({
      fullScreenSelector,
      iframeSelector,
      options = {},
      removeDraggable = false,
      selectCell = false,
      selector,
      onReadyCallback,
    }) => {
      const opts = { ...options };

      if (
        removeDraggable &&
        matchMedia("screen and (min-width: 764px)").matches
      )
        opts.draggable = false; // by default its active if we have more than 1 slide

      const slider = iframeSelector
        ? $(iframeSelector).contents().find(selector)
        : $(selector);
      const triggerResize = () => window.dispatchEvent(new Event("resize"));

      slider.imagesLoaded(() => {
        // initialize slider
        slider.flickity(opts);
        // force resize
        slider.flickity("resize");

        // trigger resize when changing slides and when entering/existing fullscreen mode
        slider.on("change.flickity", () => triggerResize());
        slider.on("fullscreenChange.flickity", () => triggerResize());

        // if we have a full screen selector we enable full screen click
        fullScreenSelector &&
          $(fullScreenSelector).on("click", function () {
            if (selectCell) {
              slider.flickity("selectCell", this, false, true);
            }
            slider.flickity("viewFullscreen");
          });
        onReadyCallback && slider.on("ready.flickity", onReadyCallback);
      });
    },
    loadSummernote: (lang) => {
      const elements = document.querySelectorAll(".j-change-translation-row");

      const checkIfElementIsVisible = (element) => {
        const rect = element.getBoundingClientRect();
        const elementIsVisible =
          rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom <=
          (window.innerHeight || document.documentElement.clientHeight) &&
          rect.right <=
          (window.innerWidth || document.documentElement.clientWidth);

        return elementIsVisible;
      };

      const hideLeftSideSummernote = (element) => {
        $(element)
          .find(".j-disable_editing")
          .find(".note-editable")
          .attr("contenteditable", false);
        $(element)
          .find(".j-disable_editing")
          .find(".note-toolbar-wrapper")
          .css("display", "none");
      };

      const isLastElement = (element) =>
        element === elements[elements.length - 1];

      const elementInsideViewport = (element) =>
        checkIfElementIsVisible(element);

      const initializeSummernote = (element) => {
        const options = {
          lang,
          height: 200,
          toolbar: [
            ["style", ["bold", "italic", "underline", "clear"]],
            ["para", ["ul", "ol"]],
            ["link", ["link"]],
          ],
          callbacks: {
            onPaste(e) {
              const bufferText = (
                (e.originalEvent || e).clipboardData || window.clipboardData
              ).getData("Text");
              e.preventDefault();
              setTimeout(() => {
                document.execCommand("insertText", false, bufferText);
              }, 10);
            },
          },
        };

        $(element).summernote(options);
      };

      const loadSummernoteOnVisibleElements = () => {
        if (!elements) return;
        elements.forEach((element, index) => {
          if (elementInsideViewport(element) && !isLastElement(element)) {
            const nextElement = elements[index + 1];
            const firstElementTargets = element.querySelectorAll(
              '[data-provider="summernote"]',
            );
            const nextElementTargets = nextElement.querySelectorAll(
              '[data-provider="summernote"]',
            );
            const summernoteTargets = [
              ...firstElementTargets,
              ...nextElementTargets,
            ];

            if (summernoteTargets.length === 0) return;

            summernoteTargets.forEach((summernoteTarget) => {
              if (
                !summernoteTarget.parentElement.querySelector(".note-editor")
              ) {
                initializeSummernote(summernoteTarget);
              }
            });
          }
          hideLeftSideSummernote(element);
        });
      };

      loadSummernoteOnVisibleElements();
    },
    initializeSegmentClickEvent: () => {
      document.querySelectorAll("[data-segment-event]").forEach((element) => {
        const { dataset } = element;
        element.addEventListener("click", () => {
          const event = dataset.segmentEvent;
          const options = window.getSegmentOptionsFromDataset(dataset);
          window.segmentTrackEvent(event, options);
        });
      });
    },
  };
})();
